var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.02333C14 3.13984 10.8617 0 7 0C3.13833 0 0 3.13984 0 7.02333C0 11.5349 5.14072 17.8928 6.61133 19.6193C6.81868 19.8628 7.18132 19.8628 7.38867 19.6193C8.85928 17.8928 14 11.5349 14 7.02333ZM7 9.80013C8.5464 9.80013 9.8 8.54652 9.8 7.00013C9.8 5.45373 8.5464 4.20013 7 4.20013C5.45361 4.20013 4.2 5.45373 4.2 7.00013C4.2 8.54652 5.45361 9.80013 7 9.80013Z",
    fill: "#5C369A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerActive);
export default __webpack_public_path__ + "static/media/mapMarkerActive.73136117b74a1b6988a841d11c1ae420.svg";
export { ForwardRef as ReactComponent };